import { FC, ReactNode } from 'react';
import styles from './FormStepLayoutProgress.module.scss';
import { CUSTOM_THEME } from '@utils';
import { Avatar, Card, CardProps, Step, StepConnector, StepIconProps, StepLabel, Stepper, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export interface IStepDefinition {
	title: ReactNode;
}

const StepIcon: FC<StepIconProps & { step: number; completedSteps?: number[] }> = ({ completed, active, step, completedSteps }) => {
	const color = active ? CUSTOM_THEME.extraColors.nightBlue : 'common.white';
	const isCompleted = (completedSteps ? completedSteps.includes(step) : false) || completed;
	let bgcolor = CUSTOM_THEME.extraColors.nightBlue;
	active && (bgcolor = 'common.white');
	isCompleted && (bgcolor = 'success.main');

	return (
		<Avatar
			sx={{
				width: 40,
				height: 40,
				bgcolor,
				color,
				borderStyle: 'solid',
				borderWidth: 2,
				borderColor: 'common.white',
				fontWeight: 600
			}}
		>
			{isCompleted && !active ? <CheckIcon fontSize="small" /> : <Typography sx={{ fontWeight: 600 }}>{step + 1}</Typography>}
		</Avatar>
	);
};

export interface IFormStepLayoutProgressProps extends CardProps {
	step: number;
	completedSteps?: number[];
	steps: IStepDefinition[];
	onStepClick?: (step: number) => void;
}

export const FormStepLayoutProgress: FC<IFormStepLayoutProgressProps> = ({ step, completedSteps, steps, onStepClick, sx, ...props }) => {
	return (
		<Card
			variant="outlined"
			sx={{ paddingX: 4, paddingY: 11, backgroundColor: CUSTOM_THEME.extraColors.nightBlue, ...sx }}
			classes={{ root: styles.FormStepLayoutProgress }}
			{...props}
		>
			<Stepper
				activeStep={step}
				nonLinear
				orientation="vertical"
				connector={<StepConnector sx={{ marginLeft: 2.5, '& .MuiStepConnector-line': { minHeight: 40 } }} />}
			>
				{steps.map(({ title }, i) => {
					return (
						<Step
							key={`vehicle-add-step-${i}`}
							sx={{ cursor: 'pointer !important' }}
							onClick={() => i !== step && onStepClick?.(i)}
						>
							<StepLabel
								sx={{ padding: 0 }}
								StepIconComponent={(stepIconProps: StepIconProps) => (
									<StepIcon {...stepIconProps} step={i} completedSteps={completedSteps} />
								)}
							>
								<Typography variant="body2" sx={{ fontWeight: 500, color: 'common.white' }}>
									{title}
								</Typography>
							</StepLabel>
						</Step>
					);
				})}
			</Stepper>
		</Card>
	);
};
